var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import OptionPicker from "../../OptionPicker";
import DefaultMessage from "../DefaultMessage";
import NotReady from "./NotReady";
import PeopleList from "./PeopleList";
import SetUpSSO from "./SetUpSSO";
import { isReadyToInvite, resetSSO, isDefaultSSO } from "../../../helpers";
// We want to merge these SSO settings changes but don't want to enable them
// until we have updated copy.  When the work is finalised this flag and
// DefaultMessage will be removed, and optionData streamlined
var displaySSOOnboarding = false;
var Invite = /** @class */ (function (_super) {
    __extends(Invite, _super);
    function Invite() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.optionData = [
            {
                selectionId: 1,
                title: "setup_tenant.steps.invite.options.ready.title",
                description: "setup_tenant.steps.invite.options.ready.description",
                actionRequiredForStepCompletion: true,
                component: React.createElement(PeopleList, { setIsStepCompletable: _this.props.setIsStepCompletable })
            },
            displaySSOOnboarding
                ? {
                    selectionId: 2,
                    title: "setup_tenant.steps.invite.options.setUpSSO.title",
                    description: "setup_tenant.steps.invite.options.setUpSSO.description",
                    actionRequiredForStepCompletion: true,
                    component: React.createElement(SetUpSSO, { setIsStepCompletable: _this.props.setIsStepCompletable })
                }
                : {
                    selectionId: 2,
                    title: "setup_tenant.steps.invite.options.notReady.title",
                    description: "setup_tenant.steps.invite.options.notReady.description",
                    actionRequiredForStepCompletion: true,
                    component: React.createElement(DefaultMessage, { message: "setup_tenant.steps.invite.options.notReady.defaultMessage" })
                }
        ];
        return _this;
    }
    Invite.prototype.render = function () {
        var _a = this.props, tenantOnboarding = _a.tenantOnboarding, setIsStepCompletable = _a.setIsStepCompletable, existingSelectionId = _a.existingSelectionId, handleOptionChange = _a.handleOptionChange;
        if (!isReadyToInvite(tenantOnboarding.assignedSteps)) {
            return React.createElement(NotReady, { tenantOnboardingSteps: tenantOnboarding.assignedSteps });
        }
        return (React.createElement(OptionPicker, { setIsStepCompletable: setIsStepCompletable, existingSelectionId: existingSelectionId, handleOptionChange: handleOptionChange, areStepSettingsDefault: function () { return isDefaultSSO(existingSelectionId === 2); }, options: this.optionData, resetToDefault: resetSSO }));
    };
    return Invite;
}(PureComponent));
export default Invite;
